import { configureStore, createSlice } from '@reduxjs/toolkit'

let svr = createSlice({
    name: 'svr',
    initialState: 'https://bg-work.cresoul.workers.dev/',
})

let lib = createSlice({
    name: 'lib',
    initialState: { modal: false, uuid: 0 },
    reducers: {
        Setlib(old, param) {
            return old = param.payload;
        }
    }
})

let img = createSlice({
    name: 'img',
    initialState: {},
    reducers: {
        SetImg: (state, action) => {
            const { key, url } = action.payload;
            state[key] = url;
        }
    }
})

let blob = createSlice({
    name: 'blob',
    initialState: [],
    reducers: {
        AddBlob: (old, param) => {
            old.push({ A: null, B: null });
        },
        SetBlob: (old, param) => {
            const { idx, slot, file } = param.payload;
            old[idx][slot] = file;
        },
        DelBlob: (old, idx) => {
            old.splice(idx.payload, 1);
        },
        ClearBlob: (old, param) => {
            return [];
        }
    }
})

let qz = createSlice({
    name: 'qz',
    initialState: null,
    reducers: {
        SetQz(old, param) {
            return old = param.payload
        },
        AddQz(old, param) {
            return old = old == null ? param.payload : [...old, ...param.payload]
        }
    }
})

let game = createSlice({
    name: 'game',
    initialState: null,
    reducers: {
        SetGame(old, param) {
            return old = param.payload;
        }
    }
})

export let { Setlib } = lib.actions
export let { SetImg } = img.actions
export let { AddBlob, SetBlob, DelBlob, ClearBlob } = blob.actions
export let { SetQz, AddQz } = qz.actions
export let { SetGame } = game.actions

export default configureStore({
    reducer: {
        svr: svr.reducer,
        lib: lib.reducer,
        img: img.reducer,
        blob: blob.reducer,
        qz: qz.reducer,
        game: game.reducer,
    },

    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})
